class BD_Block {
	constructor() {
		this._data = {};
		this._events = null;
		this._registeredEvents = [];

		/* Change this to true if your block requires server-side data */
		this._serverSide = false;

		//add current block to block list
		bdjs.registerBlock(this);
	}

	_setData(data) {
		this._data = data;
	}

	init() {
		if (this.beforeinit) this.beforeinit();
		this.registerEvents();
		if (this.afterInit) this.afterInit();
	}

	destroy() {
		if (this.beforeDestroy) this.beforeDestroy();
		this.deregisterEvents();
		if (this.afterDestroy) this.afterDestroy();
	}

	registerEvents() {
		if (!Array.isArray(this._events)) return false;

		const self = this;
		this._events.map((item) => {
			/**
			 * NOTE: don't use arrow function, because we want to pointing
			 * _this_ to the jQuery element itself
			 * @param {Event} e
			 */
			const handler = function (e) {
				item.handler.call(self, e, $(this), item.params);
			};

			this._registeredEvents.push(handler);
			// if (document == item.selector) { $(document).on(item.event, handler); return; }
			// $(document).on(item.event, item.selector, handler);
			const args = document == item.selector ? [handler] : [item.selector, handler]
			$(document).on(item.event, ...args);
		});
	}

	deregisterEvents() {
		if (!Array.isArray(this._events)) return false;
		this._events.map((item, i) => {
			const handler = this._registeredEvents[i];

			// if (document == item.selector) { $(document).off(item.event, handler); return; }
			// $(document).off(item.event, item.selector, handler);

			const args = document == item.selector ? [handler] : [item.selector, handler]
			$(document).off(item.event, ...args);
		});

		this._events = this._events.filter(e => !e.isQuestionEvent); // question event always reset
		this._registeredEvents = [];
	}
}
